module.exports = __webpack_public_path__ + "img/Slice14-min.7a1a17c5.png";